import Api from '../helpers/api';

// Settings
const FLAG_VALUE_SEPARATOR = '::';
const INVALIDATION_IN_MINUTES = 10;

// Helper Functions
function getFlagKey(flagName, institution_id) {
	return `FFLAG_${flagName}_${institution_id}`;
}
function getFlagValue(value, date = new Date()) {
	return `${value}${FLAG_VALUE_SEPARATOR}${date.toISOString()}`;
}
function parseFlagValue(rawValue) {
	const split = rawValue.split(FLAG_VALUE_SEPARATOR);
	if (split[0] && split[1]) {
		return {
			value: split[0],
			date: new Date(split[1]),
		};
	} else return null;
}

function tryParseJSON(raw) {
	try {
		return JSON.parse(raw);
	} catch (err) {
		return null;
	}
}

// Service
function getInstitutionFlags(cancelToken) {
	cancelToken = cancelToken === undefined ? null : cancelToken;
	return Api.get('/preset/feature-flag-associations', { cancelToken });
}

/*
 * Gets the flag from the cache if it is recent enough, otherwise fetches from  API
 */
async function getFlag(name, cancelToken) {
	cancelToken = cancelToken === undefined ? null : cancelToken;

	const selectedInstitutionRaw = localStorage.getItem('selected-institution');
	const selectedInstitution = JSON.parse(selectedInstitutionRaw);
	const institutionId = selectedInstitution.id;

	const cachedFlag = sessionStorage.getItem(getFlagKey(name, institutionId));
	if (cachedFlag) {
		const parsedCachedFlag = parseFlagValue(cachedFlag);
		if (parsedCachedFlag) {
			const invalidated =
				Date.now() - parsedCachedFlag.date.getTime() >=
				INVALIDATION_IN_MINUTES * 60 * 1000;
			const parsedFinalValue = tryParseJSON(parsedCachedFlag.value);
			if (!invalidated && parsedFinalValue) {
				return parsedFinalValue;
			} else {
				sessionStorage.removeItem(getFlagKey(name, institutionId));
			}
		}
	}

	try {
		const apiFlag = await Api.get(
			`/preset/feature-flag-associations/${name}` /*, { cancelToken }*/,
		);
		sessionStorage.setItem(
			getFlagKey(name, institutionId),
			getFlagValue(JSON.stringify(apiFlag), new Date()),
		);

		return apiFlag;
	} catch (err) {
		console.error(err);
		return null;
	}
}

async function toggleFlag(name, active) {
	const selectedInstitutionRaw = localStorage.getItem('selected-institution');
	const selectedInstitution = JSON.parse(selectedInstitutionRaw);
	const institutionId = selectedInstitution.id;

	const cachedFlag = sessionStorage.getItem(getFlagKey(name, institutionId));

	let parsedFlag;
	if (cachedFlag) {
		const parsedCachedFlag = parseFlagValue(cachedFlag);
		if (parsedCachedFlag && parsedCachedFlag.value) {
			parsedFlag = JSON.parse(parsedCachedFlag.value);
			parsedFlag.value = active;
		}
	}

	try {
		const response = await Api.post(
			'/preset/feature-flag-associations/toggle',
			{
				name,
				active,
			},
		);
		if (response && response.message == 'success' && parsedFlag) {
			sessionStorage.setItem(
				getFlagKey(name, institutionId),
				getFlagValue(JSON.stringify(parsedFlag), new Date()),
			);
		}
	} catch (err) {
		console.error(err);
	}
}

export const featureFlagsService = {
	getInstitutionFlags,
	getFlag,
	toggleFlag,
};
